import {GET_SPONSOR_COUNT } from '../../actiontypes'

export const SponsorCountReducer = (sponsorcount) => {
    return (dispatch) => {
            dispatch({ type: GET_SPONSOR_COUNT, payload: sponsorcount});
    }      
};